import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PlanPhaseTypeEnum } from '../../models/crm/types';
import { NullableString } from '../../util/types';

export enum AccountEndReason {
  Passed = 'passed',
  Failed = 'failed',
  Unknown = 'unknown',
}

export type AccountFinishedPayload = {
  accountReferenceId: string;
  reason: AccountEndReason;
  phase?: PlanPhaseTypeEnum;
};

export type AccountFlowState = {
  finishedAccountReference: NullableString;
  finishedReason: AccountEndReason | null;
  finishedPhase: PlanPhaseTypeEnum | null;
};

export const INITIAL_STATE: AccountFlowState = {
  finishedAccountReference: null,
  finishedReason: null,
  finishedPhase: null,
};

const accountFlowSlice = createSlice({
  name: 'accountFlow',
  initialState: INITIAL_STATE,
  reducers: {
    accountFinished(state, action: PayloadAction<AccountFinishedPayload>) {
      const { accountReferenceId, reason } = action.payload;
      const isSameAccount = state.finishedAccountReference === accountReferenceId;
      const isKnownAlready = state.finishedReason !== null && state.finishedReason !== AccountEndReason.Unknown;

      if (isSameAccount && isKnownAlready) {
        return;
      }

      if (!isSameAccount) {
        state.finishedPhase = null;
      }

      state.finishedAccountReference = accountReferenceId;
      state.finishedReason = reason;
      state.finishedPhase = action.payload.phase ?? state.finishedPhase;
    },
  },
});

export const { accountFinished } = accountFlowSlice.actions;

export default accountFlowSlice.reducer;
